import type { ImageLoader, ImageProps } from 'next/image'

const SESSION_MEDIA_PREFIXES = [
  '/assets/',
  '/generated/',
  '/studio-assets/',
  '/studio-raw/',
  '/api/media/',
  '/api/fileserver/protected/',
]

/** 인증 이미지 요청은 브라우저가 직접 보내야 세션 쿠키가 전달된다. */
export function isSessionMediaImage(
  src: ImageProps['src'] | undefined
): boolean {
  if (typeof src !== 'string') return false

  try {
    const url = new URL(src, 'https://veluvit.local/')
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false

    return SESSION_MEDIA_PREFIXES.some((prefix) =>
      url.pathname.startsWith(prefix)
    )
  } catch {
    return false
  }
}

const MEDIA_ASSET = /^\/api\/media\/[a-z0-9]{32}\/$/
/** 서버 목록 축소본(/thumb/)이 원본과 같은 선명도로 덮는 최대 폭 — 긴 변 1080px 이면 2:3 세로 그림도 폭 720px */
const THUMB_WIDTH = 720

/** 업로드 미디어 원본 주소인가 — 축소본(/thumb/)을 고를 수 있는 그림 */
export function isMediaAsset(
  src: ImageProps['src'] | undefined
): src is string {
  return typeof src === 'string' && MEDIA_ASSET.test(src)
}

/** 표시 폭이 작으면 축소본, 크면 원본 — 브라우저가 srcset 에서 고른다. 최적화 서버를 거치지 않아 세션 쿠키가 그대로 간다 */
export const mediaLoader: ImageLoader = ({ src, width }) =>
  isMediaAsset(src) && width <= THUMB_WIDTH ? `${src}thumb/` : src
